import "./style.scss";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function treatment_process_block() {
  const blocks = document.querySelectorAll(".treatment_process_block");
  if (!blocks.length) return;

  blocks.forEach((block) => {
    const ctx = gsap.context(() => {

      const stepsInner = block.querySelector(".scroller");
      const steps = gsap.utils.toArray(block.querySelectorAll(".step"));
      const progressBar = block.querySelector(".progress-bar");
      const progressWrapper = block.querySelector(".progress-wrapper");
      const progressDot = block.querySelector(".progress-dot");
      const scroller = block.querySelector(".right-content");

      if (!steps.length || !stepsInner || !progressBar || !progressDot || !scroller) return;

      const totalSteps = steps.length;
      let currentIndex = -1;

      /* ---------------------------------------
         Dynamic pin duration
      --------------------------------------- */
      const getPinDuration = () => {
        const visible = scroller.offsetHeight;
        const total = stepsInner.scrollHeight;
        return Math.max(total, visible * 1.5);
      };

      /* ---------------------------------------
         Timeline
      --------------------------------------- */
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: scroller,
          start: "center center",
          end: () => `+=${getPinDuration()}`,
          pin: block,
          scrub: 1,
          invalidateOnRefresh: true,
        },
      });

      /* ---------------------------------------
         Vertical content scroll
      --------------------------------------- */
      tl.to(
        stepsInner,
        {
          y: () => {
            const visible = scroller.offsetHeight;
            const total = stepsInner.scrollHeight;
            return total > visible ? -(total - visible) : 0;
          },
          ease: "none",
        },
        0
      );

      /* ---------------------------------------
         Sync Progress + States
      --------------------------------------- */
      tl.eventCallback("onUpdate", () => {
        const progress = tl.progress();

        /* ---- Progress bar scale ---- */
        gsap.set(progressBar, {
          scaleY: progress,
          transformOrigin: "top center",
        });

        /* ---- Move dot ---- */
        const wrapperHeight = progressWrapper.offsetHeight;

        gsap.set(progressDot, {
          y: wrapperHeight * progress,
        });

        /* ---- Step activation ---- */
        const index = Math.round(
          progress * (totalSteps - 1)
        );

        if (index === currentIndex) return;

        steps.forEach((step, i) => {
          step.classList.toggle("is-active", i === index);
          step.classList.toggle("is-visited", i < index);
        });

        currentIndex = index;
      });

    }, block);

    // optional cleanup support if needed
    // return () => ctx.revert();
  });
}
